/* eslint-disable react/prop-types */
import { useTranslation } from "react-i18next";
import "./ProductCardSizePicker.css";
import {
  PRODUCT_CARD_SIZES,
  normalizeProductCardSize,
} from "../../../constants/productCardSizes";

const SIZE_LABEL_KEYS = {
  small: "productCardSizeSmall",
  normal: "productCardSizeNormal",
  big: "productCardSizeBig",
};

const ProductCardSizePicker = ({ value, onChange, idPrefix = "menu-card-size" }) => {
  const { t } = useTranslation();
  const id = `${idPrefix}-card-size`;
  const normalized = normalizeProductCardSize(value);

  return (
    <div className="menu-card-size-picker">
      <label htmlFor={id} className="menu-card-size-picker__title">
        {t("productCardSizeLabel")}
      </label>
      <p className="menu-card-size-picker__hint">{t("productCardSizeHint")}</p>
      <select
        id={id}
        className="form-select menu-card-size-picker__select"
        value={normalized}
        onChange={(e) => onChange(e.target.value)}
        aria-label={t("productCardSizeLabel")}
      >
        {PRODUCT_CARD_SIZES.map((size) => (
          <option key={size} value={size}>
            {t(SIZE_LABEL_KEYS[size])}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ProductCardSizePicker;
